import type { HTMLAttributes } from 'react';
import styles from './SettingsGroup.module.css';

export const SettingsGroup = ({ className, ...rest }: HTMLAttributes<HTMLDivElement>) => (
  <div className={[styles['group'], className ?? ''].join(' ')} {...rest} />
);
